import { SummaryTotalsOut } from '../../store/api';
import { shopPrefix } from '../../config';
import { isNotBlank, isPresent, validateAll, validateAndLogOnErrors, validateField } from '../validation';
import { http } from '../axios';

const FETCH_CART_SUMMARY_URL = `${shopPrefix}/v1/shoppingcart/summary`;

export type FetchCartSummaryResponse = {
    comingSoonProductsAmount: number;
    currency: string;
    eaudiobooksAmount: number;
    eaudiobooksProductAmount: number;
    eaudiobooksValue: number;
    ebooksAmount: number;
    ebooksProductAmount: number;
    epressAmount: number;
    epressProductAmount: number;
    epressValue: number;
    ebooksValue: number;
    totalNetValue: number;
    totalTaxValue: number;
    totalValue: number;
    unavailableProductsAmount: number;
};

export const fetchCartSummary = (): Promise<FetchCartSummaryResponse> => {
    return http.get<SummaryTotalsOut>(FETCH_CART_SUMMARY_URL).then(response => mapCartSummary(response.data));
};

const isSummaryTotalsOutValid = (summary: SummaryTotalsOut): boolean => {
    return validateAndLogOnErrors(
        validateAll<SummaryTotalsOut>(validateField('currency', validateAll(isPresent, isNotBlank))),
        summary
    );
};

const mapCartSummary = (resp: SummaryTotalsOut): FetchCartSummaryResponse => {
    if (!isSummaryTotalsOutValid(resp)) {
        throw new Error('cart summary validation failed');
    }

    return {
        comingSoonProductsAmount: resp.comingSoonProductsAmount ?? 0,
        currency: resp.currency!,
        eaudiobooksAmount: resp.eaudiobooksAmount ?? 0,
        eaudiobooksProductAmount: resp.eaudiobooksProductAmount ?? 0,
        eaudiobooksValue: resp.eaudiobooksValue ?? 0,
        ebooksAmount: resp.ebooksAmount ?? 0,
        ebooksProductAmount: resp.ebooksProductAmount ?? 0,
        epressAmount: resp.epressAmount ?? 0,
        epressProductAmount: resp.epressProductAmount ?? 0,
        epressValue: resp.epressValue ?? 0,
        ebooksValue: resp.ebooksValue ?? 0,
        totalNetValue: resp.totalNetValue ?? 0,
        totalTaxValue: resp.totalTaxValue ?? 0,
        totalValue: resp.totalValue ?? 0,
        unavailableProductsAmount: resp.unavailableProductsAmount ?? 0
    };
};
